import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { TextField } from "@shared/components/TextField";
import { FormErrorMessage } from "@shared/components/FormErrorMessage";
import { usaStates } from "@shared/utils/data/usaStates";

type StateFieldProps = {
  country: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  fieldError?: { message?: string };
};

export const StateField = (props: StateFieldProps) => {
  const { country, name, value, onChange, onBlur, fieldError } = props;

  if (country !== "US") {
    return (
      <TextField
        label="State / Province / Region"
        name={name}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        fieldError={fieldError}
      />
    );
  }

  const label = "State";
  const labelId = `${name}-label`;

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        name={name}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        error={!!fieldError?.message}
      >
        {usaStates.map((state) => (
          <MenuItem key={state.abbreviation} value={state.abbreviation}>
            {state.abbreviation}
          </MenuItem>
        ))}
      </Select>
      <FormErrorMessage>{fieldError?.message ?? " "}</FormErrorMessage>
    </FormControl>
  );
};
